'use client'
import React from 'react'

import { Button, ButtonIconPosition, BaseButtonProps, ButtonVariants, TextPosition } from '../../../atoms'

export interface ContextMenuItemProps extends BaseButtonProps {
    children: React.ReactNode
    disabled?: boolean
    buttonVariant?: ButtonVariants
    onClick?: () => void
}

export const ContextMenuItem = ({
    children,
    disabled,
    buttonVariant = ButtonVariants.DEFAULT_CONTEXT_MENU_ITEM,
    icon,
    ...rest
}: ContextMenuItemProps) => {
    return (
        <Button
            className="context-menu__item"
            variant={buttonVariant}
            disabled={disabled}
            textPosition={TextPosition.LEFT}
            {...rest}
        >
            {!!icon && (
                <span
                    className={`absolute ${
                        !rest.iconPosition || rest.iconPosition === ButtonIconPosition.LEFT ? 'left-0' : 'right-0'
                    }`}
                >
                    {icon}
                </span>
            )}
            <span className="mx-2">{children}</span>
        </Button>
    )
}

export default ContextMenuItem
